module.exports = __webpack_public_path__ + "img/float-btn-cockfigh.cd0a3153.svg";